/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EvalTask,
  EvalTask$inboundSchema,
  EvalTask$Outbound,
  EvalTask$outboundSchema,
} from "./evaltask.js";

export type EvalSuiteManifest = {
  schemaVersion?: string | undefined;
  tasks: Array<EvalTask>;
  metadata?: { [k: string]: any } | undefined;
};

/** @internal */
export const EvalSuiteManifest$inboundSchema: z.ZodType<
  EvalSuiteManifest,
  z.ZodTypeDef,
  unknown
> = z.object({
  schema_version: z.string().default("2026-05-27"),
  tasks: z.array(EvalTask$inboundSchema),
  metadata: z.record(z.any()).optional(),
}).transform((v) => {
  return remap$(v, {
    "schema_version": "schemaVersion",
  });
});
/** @internal */
export type EvalSuiteManifest$Outbound = {
  schema_version: string;
  tasks: Array<EvalTask$Outbound>;
  metadata?: { [k: string]: any } | undefined;
};

/** @internal */
export const EvalSuiteManifest$outboundSchema: z.ZodType<
  EvalSuiteManifest$Outbound,
  z.ZodTypeDef,
  EvalSuiteManifest
> = z.object({
  schemaVersion: z.string().default("2026-05-27"),
  tasks: z.array(EvalTask$outboundSchema),
  metadata: z.record(z.any()).optional(),
}).transform((v) => {
  return remap$(v, {
    schemaVersion: "schema_version",
  });
});

export function evalSuiteManifestToJSON(
  evalSuiteManifest: EvalSuiteManifest,
): string {
  return JSON.stringify(
    EvalSuiteManifest$outboundSchema.parse(evalSuiteManifest),
  );
}
export function evalSuiteManifestFromJSON(
  jsonString: string,
): SafeParseResult<EvalSuiteManifest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EvalSuiteManifest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EvalSuiteManifest' from JSON`,
  );
}
